// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link[data-v-15fb9be2]{cursor:pointer}.link .v-icon[data-v-15fb9be2]{opacity:0}.link[data-v-15fb9be2]:hover{color:#424242}.link:hover .v-icon[data-v-15fb9be2]{color:#424242;opacity:.6}.link.sorted .v-icon[data-v-15fb9be2]{opacity:1}", ""]);
// Exports
module.exports = exports;
